import script from "./ViewTasks.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewTasks.vue?vue&type=script&setup=true&lang=js"

import "./ViewTasks.vue?vue&type=style&index=0&id=0c47fbd6&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/duanju-overseas_admin_vue_live/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c47fbd6"]])

export default __exports__